import { Parser } from '@json2csv/plainjs'
import fileDownload from 'js-file-download'
import { useTranslation } from 'react-i18next'

import CsvIcon from '@/assets/icons/csv-download.svg'
import CustomButton from '@/components/inputs/CustomButton'
import type { RevenueDataRow } from '@/features/site/types/revenue'
import type { MarketProgramType } from '@/types/marketProgramType'

type ExportCsvButtonProps = {
  data: RevenueDataRow[]
  year: string
  marketProgramType: string
  siteName: string
}
const CsvDownloadIcon = () => <img alt="Csv Icon" src={CsvIcon} />

export function ExportCsvButton({ data, year, marketProgramType, siteName }: Readonly<ExportCsvButtonProps>) {
  const { t } = useTranslation()
  const exportCsv = () => {
    const translatedTimestamp = t('customer_revenue.timestamp')
    const translatedCapacity = t('customer_revenue.capacity')
    const translatedSoldCapacity = t('customer_revenue.sold_capacity')
    const translatedRevenue = t('customer_revenue.revenue.label')
    const columnLabels = [translatedTimestamp, translatedCapacity, translatedSoldCapacity, translatedRevenue]

    const csvData: Record<string, any> = []
    for (const row of data) {
      csvData.push({
        [translatedTimestamp]: row.timestamp,
        [translatedCapacity]: row.capacity,
        [translatedSoldCapacity]: row.soldCapacity,
        [translatedRevenue]: row.revenue,
      })
    }

    const parser = new Parser({
      fields: columnLabels,
    })
    const csv = parser.parse(csvData)
    const translatedRevenues = t('customer_revenue.csv_export.revenues')

    const fileName = marketProgramType
      ? `${t('customer_revenue.csv_export.revenues')} - ${year} - ${t(
          `common.market_program.${marketProgramType as MarketProgramType}`,
        )} - ${siteName}.csv`
      : `${translatedRevenues} - ${year} - ${siteName}.csv`
    return fileDownload(csv, fileName)
  }

  return (
    <CustomButton startIcon={<CsvDownloadIcon />} variant="outlinedWhite" onClick={exportCsv}>
      {t('customer_revenue.csv_export.export')}
    </CustomButton>
  )
}
